import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function LatestNews() {
  const featured = articles.filter((a) => a.isFeatured);
  const others = articles.filter((a) => !a.isFeatured);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500">深度赛事报道与专业分析</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-6">
          {featured.map((article) => {
            const cat = categories.find((c) => c.id === article.categoryId);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="aspect-[2/1] overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {cat?.name}
                    </span>
                    <span className="text-xs text-foreground-500">{article.publishDate}</span>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.summary}
                  </p>
                  <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200">
                    <span className="text-xs text-foreground-500">{article.author}</span>
                    <span className="text-xs text-foreground-400">{article.views.toLocaleString()} 阅读</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          {others.map((article) => {
            const cat = categories.find((c) => c.id === article.categoryId);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
              >
                <div className="aspect-[16/9] rounded-md overflow-hidden mb-3">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                  {cat?.name}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{article.publishDate}</span>
                  <span>·</span>
                  <span>{article.views.toLocaleString()} 阅读</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}